import React from "react";

/**
 * @component CheckIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CheckIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CheckIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CheckIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M5.613 10.21l.094.083L10 14.585l8.293-8.292a1 1 0 011.497 1.32l-.083.094-9 9a1 1 0 01-1.414 0l-5-5a1 1 0 011.32-1.497z"
        fillRule="evenodd"
      />
    </svg>
  )
);
CheckIcon.displayName = "CheckIcon";
export default CheckIcon;
